import { render, staticRenderFns } from "./PreliminaryReportAdmin.vue?vue&type=template&id=979b9e60&"
import script from "./PreliminaryReportAdmin.vue?vue&type=script&lang=ts&"
export * from "./PreliminaryReportAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports